import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { getFields, useInfractions } from 'admin/lib/Records'

/**
 *
 * @param {string} selectedField
 * @param {import('../Records/fields').Delivery} fields
 */
export function useFieldOptions(selectedField) {
  const { moduleName } = useParams()
  const fields = useMemo(() => getFields(moduleName), [moduleName])

  const infractionsByPath = useInfractions()

  const fieldOptions = useMemo(() => {
    const dataFields = Object.values(fields.data)
      .filter(field => field.infractionOpts.infractable)
      .map(field => ({
        ...field,
        type: 'data',
        pathTail: field.path,
        infractions: infractionsByPath[field.path] ?? []
      }))

    return [...dataFields]
  }, [fields.data, infractionsByPath])

  const selectedFieldOption = useMemo(() => {
    const DEFAULT = {
      type: 'unknown',
      path: null,
      pathTail: null,
      label: null,
      infractions: []
    }
    if (selectedField && fieldOptions.length) {
      return fieldOptions.find(opt => opt.path === selectedField) ?? DEFAULT
    }
    return DEFAULT
  }, [fieldOptions, selectedField])

  return {
    fieldOptions,
    selectedFieldOption
  }
}
